import { useStatQuery } from '@famly/stat_use-stat-query';
import { useSubscribeAddLeaveSubtypeMutationResult, useSubscribeEditLeaveSubtypeMutationResult, } from '@famly/stat_add-edit-leave-subtype_data';
import { FetchLeaveSubtypesQuery } from './fetch-leave-subtypes.query';
import { useSubscribeDeleteLeaveSubtypeResult } from './use-delete-leave-subtype';
/**
 * Hook to fetch leave subtypes for absence management settings.
 *
 * @param options - Apollo query options including variables.
 * @returns Query result with leave subtypes data and loading state.
 */
export const useFetchLeaveSubtypes = (options) => {
    const queryResult = useStatQuery(FetchLeaveSubtypesQuery, options);
    useSubscribeAddLeaveSubtypeMutationResult(result => {
        if (result) {
            const newSubtype = result.staffhours.leaves.subtypes.createV2;
            queryResult.updateQuery(cached => {
                const alreadyExists = cached.staffhours.leaves.subtypes.listV2.some(subtype => subtype.id === newSubtype.id);
                if (!alreadyExists) {
                    cached.staffhours.leaves.subtypes.listV2 = [
                        ...cached.staffhours.leaves.subtypes.listV2,
                        newSubtype,
                    ];
                }
                return cached;
            });
        }
    });
    useSubscribeEditLeaveSubtypeMutationResult(result => {
        if (result) {
            const updatedSubtype = result.staffhours.leaves.subtypes.updateV2;
            queryResult.updateQuery(cached => {
                cached.staffhours.leaves.subtypes.listV2 = cached.staffhours.leaves.subtypes.listV2.map(subtype => subtype.id === updatedSubtype.id ? updatedSubtype : subtype);
                return cached;
            });
        }
    });
    useSubscribeDeleteLeaveSubtypeResult((result, mutationOptions) => {
        if (result && (mutationOptions === null || mutationOptions === void 0 ? void 0 : mutationOptions.variables)) {
            const deletedIds = mutationOptions.variables.leaveSubTypeIds;
            queryResult.updateQuery(cached => {
                cached.staffhours.leaves.subtypes.listV2 = cached.staffhours.leaves.subtypes.listV2.filter(subtype => !deletedIds.includes(subtype.id));
                return cached;
            });
        }
    });
    return queryResult;
};
